import { supabase } from '../lib/supabaseClient';

export async function fetchSavedEventsById(userId) {
  const { data, error } = await supabase
    .from('saved_events')
    .select('event_id, event_payload')
    .eq('user_id', userId);

  if (error) throw error;

  return (data || []).reduce((acc, row) => {
    if (!row?.event_id || !row?.event_payload) return acc;
    acc[row.event_id] = row.event_payload;
    return acc;
  }, {});
}

export async function upsertSavedEvent(userId, event) {
  const { error } = await supabase
    .from('saved_events')
    .upsert(
      [{
        user_id: userId,
        event_id: event.id,
        event_payload: event,
      }],
      { onConflict: 'user_id,event_id' }
    );

  if (error) throw error;
}

export async function deleteSavedEvent(userId, eventId) {
  const { data, error } = await supabase
    .from('saved_events')
    .delete()
    .select('event_id')
    .eq('user_id', userId)
    .eq('event_id', eventId);

  if (error) throw error;

  if (!data?.length) {
    throw new Error(`Saved event delete affected 0 rows for event ${eventId}.`);
  }
}

export async function syncSavedEvents(userId, eventsById) {
  const rows = Object.values(eventsById || {})
    .filter((event) => event?.id)
    .map((event) => ({
      user_id: userId,
      event_id: event.id,
      event_payload: event,
    }));

  if (!rows.length) return;

  const { error } = await supabase
    .from('saved_events')
    .upsert(rows, { onConflict: 'user_id,event_id' });

  if (error) throw error;
}
